module.exports = "/lucky-balls/img/fast-arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/fast-arrow-right.png
// module id = 232
// module chunks = 0